<template>
  <div>

    <div class="pwwrap pwstyle_01">
      <h2 class="modal-title text-center mb-1">November 2023</h2>
      <div class="text text-center">
        <div class="body">
          <p>The Exchange TRX lifestyle hub opens its doors to the public with over 400 retail
            stores and many first-to-market brands</p>
        </div>
      </div>
    </div>

    <div class="milestones-year-content" :style="styleBgMilesModal">
      <div class="container">
        <div class="row">
          <!-- <div class="col-12"></div> -->
          <!-- <div class="col-md-8 offset-md-2"></div> -->
          <div class="col-12">

            <slick v-if="data_image" ref="slick" :options="slickOptionsP22023"
                class="milestones-year-slide-items">
              <div class="milestones-year-slide-item position-relative"
                  v-for="(item, index) in data_image" :key="index">

                <div class="milestones-year-slide-img slide-img-only">
                  <img v-if="item" :src="item.img" :alt="'milestones-year-' + index"
                      class="img-fluid">
                </div>

              </div>
            </slick>

            <div class="pwwrap pwstyle_01">
              <h3 class="modal-title text-center">THE EXCHANGE TRX LIFESTYLE HUB OPENS TO
                PUBLIC</h3>
            </div>

            <div class="pwwrap pwstyle_01 mb-5">
              <div class="text">
                <div class="body">
                  <p>The Exchange TRX opened its doors to visitors on 29 November 2023. The
                    lifestyle destination features shopping, dining, leisure, and entertainment options with
                    over 400 stores across 1.3 million sq. ft. of Nett Lettable Area (NLA). Among its
                    first-to-market brands include Gentle Monster, Maison Kitsune, Alo Yoga, and Drunk
                    Elephant. Anchor tenant Seibu, one of Japan’s largest department stores,
                    occupies around 250,000 sq ft over four floors. On the rooftop of the lifestyle hub sits
                    the 10-acre city park with ample greenery and play areas.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jQuery from 'jquery';
import AOS from 'aos';
import axios from 'axios';
import Slick from 'vue-slick';
import 'slick-carousel/slick/slick.css';
import slickLeft from '@/assets/arrow-prev-transparent.png';
import slickRight from '@/assets/arrow-next-transparent.png';

import styleBgFooter from '@/assets/bg-footer.svg';
import btnNewTab from '@/assets/ico-newtab.png';

import MileClose from '@/assets/ico-milestones-modal-close.png';
import MileModalBG from '@/assets/ideation/ideation-09-milestone-modal-bg-01.jpg';

// import videoMemorandumMOV from '@/assets/ideation/milestone/phase2-2013/Investor_Memorandum_Video_Final.mp4'

import MileP21401 from '@/assets/ideation/milestone/phase2-2014/phase2-2014-01.jpg';
import MileP21402 from '@/assets/ideation/milestone/phase2-2014/phase2-2014-02.jpg';
import MileP21403 from '@/assets/ideation/milestone/phase2-2014/phase2-2014-03.jpg';
import MileP21404 from '@/assets/ideation/milestone/phase2-2014/phase2-2014-04.jpg';

export default {
  name: 'IdeationTimelinePhase22023',
  components: {
    Slick,
    //   phase1inner1
  },
  // props: {
  // msg: String
  // }
  data: function() {
    return {
      apiBasePath: 'https://trx-api.okie.my/',
      // dataToken: [],
      // dataTokenParaInner: [],
      btnNewTab: btnNewTab,
      slickLeft: slickLeft,
      slickRight: slickRight,
      MileClose: MileClose,
      data_image: [
        {
          img: require('@/assets/ideation/milestone/phase2-2023-01/DSC01464.jpg'),
          title: 'Mall Launch',
        },
        {
          img: require('@/assets/ideation/milestone/phase2-2023-01/DSC01486.jpg'),
          title: 'Mall Launch',
        },
        {
          img: require('@/assets/ideation/milestone/phase2-2023-01/DSC01581.jpg'),
          title: 'Mall Launch',
        },
        {
          img: require('@/assets/ideation/milestone/phase2-2023-01/DSC01616.jpg'),
          title: 'Mall Launch',
        },
        {
          img: require('@/assets/ideation/milestone/phase2-2023-01/TheExchange-TRX-Farsya.A-133.jpg'),
          title: 'Mall Launch',
        },
      ],
      slickOptionsP22023: {
        slidesToShow: 3,
        arrows: true,
        infinite: true,
        nextArrow: '<button type="button" class="slick-next slick-arrow"><img src="' + slickRight + '"></button>',
        prevArrow: '<button type="button" class="slick-prev slick-arrow"><img src="' + slickLeft + '"></button>',
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    styleBgFooterCss() {
      return {
        'background-image': 'url(' + styleBgFooter + ')',
        'background-repeat': 'no-repeat',
        'background-size': 'cover',
      };
    },
    styleBgMilesModal() {
      return {
        'background-image': 'url(' + MileModalBG + ')',
        'background-repeat': 'no-repeat',
        'background-size': '100% auto',
        'background-position': 'center top',
      };
    },
  },
  mounted: function() {
    // this.getData();
    // $(window).on('load',function(){AOS.refresh();});
  },
  // methods: {
  //   close() {
  //     this.$emit('openITLSecond');
  //   },
  // },
};
</script>